require('../../models/event/eventDiscipline');
require('../../modules/pagination/pagination');
require('../../modules/maps/maps');

angular.module('far.events.search', [
        'dekky.pagination',
        'far.models.event.discipline',
        'far.maps'
    ])
    .controller('EventsSearchController', function (
                                                    $rootScope,
                                                    $log,
                                                    $http,
                                                    $window,
                                                    $timeout,
                                                    $q,
                                                    pagination,
                                                    eventDiscipline,
                                                    uiGmapGoogleMapApi,
                                                    maps) {
        var googleMaps,
            itemsOnList = 12,
            itemsOnMap = 1000;

        var vm = {
            init: function(selectedDisciplineId) {
                if (selectedDisciplineId > 0) {
                    vm.selectedDisciplineId = selectedDisciplineId;
                    vm.filters.disciplines.push(selectedDisciplineId);
                    vm.filters.eventData.application.value = false;
                    vm.filters.eventData.education.value = false;
                    vm.filters.eventData.project.value = false;
                }
            },
            selectedDisciplineId: null,
            constructor: constructor,
            pagination: pagination('events', {next: nextPage, itemsOnPage: itemsOnMap}),
            type: 3,
            disciplines: eventDiscipline.list,
            filters: {
                period: 'all',
                dateFrom: undefined,
                dateTo: undefined,
                disciplines: [],
                eventData: {
                    application: {
                        value: true,
                        disabled: false
                    },
                    education: {
                        value: true,
                        disabled: false
                    },
                    competition: {
                        value: true,
                        memory: null,
                        disabled: false
                    },
                    project: {
                        value: true,
                        disabled: false
                    }
                }
            },
            applyFilters: applyFilters,
            showFilters: true,
            map: {
                center: maps.getDefaultCenter(),
                zoom: maps.getDefaultZoom(),
                disableDefaultUI: true,
                options: {
                    maxZoom: 12,
                    disableDefaultUI: true,
                    zoomControl: true,
                    scrollwheel: false,
                    styles: maps.getStyle()
                },
                markerEvents: {
                    click: function (marker, event, item) {
                        var infoWindow = getInfoWindow(item);

                        for (var iw in vm.map.infoWindows) {
                            vm.map.infoWindows[iw].close();
                        }

                        infoWindow.open(marker.map, marker);
                    }
                },
                infoWindows: {}
            },
            modal_choose: false,
            whatShow: 'map',
            showMap: showMap,
            showList: showList,
            showLast: showLast,
            showNear: showNear,
            eventRequest: function () {
                $window.location.href = Routing.generate('event_request', {type: vm.eventType});
            },
            changePeriod: function () {
                if (vm.filters.period == 'all_year_round') {
                    if (vm.filters.eventData.competition.value) {
                        vm.filters.eventData.competition.memory = true;
                    } else {
                        vm.filters.eventData.competition.memory = null;
                    }

                    vm.filters.eventData.competition.value = false;
                    vm.filters.eventData.competition.disabled = true;
                } else {
                    if (vm.filters.eventData.competition.memory) {
                        vm.filters.eventData.competition.value = true;
                    }

                    vm.filters.eventData.competition.memory = null;
                    vm.filters.eventData.competition.disabled = false;
                }
            },
            clearFilters: function () {
                vm.filters = {
                    period: 'all',
                    dateFrom: null,
                    dateTo: null,
                    disciplines: [],
                    eventData: {
                        application: {
                            value: true,
                            disabled: false
                        },
                        education: {
                            value: true,
                            disabled: false
                        },
                        competition: {
                            value: true,
                            memory: null,
                            disabled: false
                        },
                        project: {
                            value: true,
                            disabled: false
                        }
                    }
                };

                angular.forEach(vm.disciplines, function(discipline) {
                    discipline.selected = false;
                });

            }
        };

        //После загрузки дисциплин помечаем выбранную ид которой приходит с url: /events/discipline-1
        $rootScope.$watch(function() {
            return vm.disciplines.length;
        }, function(length) {
            if (length > 0 && vm.selectedDisciplineId) {
                angular.forEach(vm.disciplines, function(discipline) {
                    if (discipline.id == vm.selectedDisciplineId) {
                        discipline.selected = true;
                    }
                });
            }
        });

        uiGmapGoogleMapApi.then(function (maps) {
            googleMaps = maps;
        });

        function constructor(userId, type) {
            vm.userId = userId;
            vm.type = type;
        }

        function showMap() {
            vm.whatShow = 'map';
            vm.filters.dateLast = null;
            vm.filters.dateFrom = new Date('2000-01-01');
            vm.pagination.changeItemsOnPage(itemsOnMap);
        }

        function showList() {
            vm.whatShow = 'list';
            vm.filters.dateLast = null;
            vm.filters.dateFrom = new Date('2000-01-01');
            vm.pagination.changeItemsOnPage(itemsOnList);
        }

        function showLast() {
            vm.whatShow = 'last';
            vm.filters.dateLast = new Date();
            vm.filters.dateFrom = new Date('2000-01-01');
            vm.pagination.changeItemsOnPage(itemsOnList);
        }

        function showNear() {
            vm.whatShow = 'near';
            vm.filters.dateLast = null;
            vm.filters.dateFrom = new Date();
            vm.pagination.changeItemsOnPage(itemsOnList);
        }

        function applyFilters() {
            vm.filters.disciplines = vm.disciplines.filter(function (discipline) {
                return discipline.selected;
            }).map(function (discipline) {
                return discipline.id;
            });

            vm.pagination.clear();
        }

        function getInfoWindow(item) {
            if (!vm.map.infoWindows[item.id]) {
                vm.map.infoWindows[item.id] = new googleMaps.InfoWindow({
                    content:
                        '<div class="map-info-window">' +
                            '<p class="content__date">' + ((item.all_year_round) ? 'Круглогодично': item.dates) +'</p>' +
                            '<h4>' + item.name + '</h4>' +
                            '<p><a href="' + item.event_url + '" class="btn-link" target="_blank">Подробнее</a></p>' +
                        '</div>'
                });
            }

            return vm.map.infoWindows[item.id];
        }

        function nextPage(page, count) {
            var data = {
                event_data: {},
                type: vm.type,
                offset: (page - 1) * count,
                limit: count,
                period: vm.filters.period,
                disciplines: vm.filters.disciplines.join(','),
                date: {
                    from: null,
                    to: null,
                    last: null
                }
            };

            if (angular.isDate(vm.filters.dateFrom)) {
                data.date.from = [vm.filters.dateFrom.getFullYear(), (vm.filters.dateFrom.getMonth() + 1), vm.filters.dateFrom.getDate()].join('-');
            }

            if (angular.isDate(vm.filters.dateTo)) {
                data.date.to = [vm.filters.dateTo.getFullYear(), (vm.filters.dateTo.getMonth() + 1), vm.filters.dateTo.getDate()].join('-');
            }

            if (angular.isDate(vm.filters.dateLast)) {
                data.date.last = [vm.filters.dateLast.getFullYear(), (vm.filters.dateLast.getMonth() + 1), vm.filters.dateLast.getDate()].join('-');
            }

            for (var eventDataKey in vm.filters.eventData) {
                data.event_data[eventDataKey] = +vm.filters.eventData[eventDataKey].value;
            }

            return $http.get(Routing.generate('api_event_get_eventplans', data)).then(function (response) {
                var items = [];
                vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

                angular.forEach(response.data, function (item) {
                    item.markerOptions = {
                        clickable: true
                    };
                    item.map = {infoWindow: null};

                    items.push(item);
                });

                return items;
            }).catch(function (response) {
                $log.error(response);
                return $q.reject(response);
            });
        }

        return vm;
    });
